import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { fetchBillReportUrl } from '../api/parking-billing.ts';

export default function useDownloadBillingReport(): UseMutationResult<
  string,
  Error,
  string
> {
  return useMutation({
    mutationFn: (id) => fetchBillReportUrl(id),
    onSuccess: (url) => {
      // 透過動態建立 <a> 標籤來下載
      const link = document.createElement('a');
      link.href = url;
      link.download = ''; // 不設定時，會使用伺服器回傳的檔名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  });
}
